/**
 * Vocabulário das situações de uma instância.
 *
 * São seis desfechos diferentes e a tela precisa distingui-los, porque a ação
 * que cada um pede é outra:
 *
 * - online / carregada offline: está no pod certo; offline pode ser o celular do
 *   lojista fora do ar, não um problema de infraestrutura.
 * - não carregada: o banco manda para um pod que não tem a sessão em memória.
 *   Some do ar até alguém carregar (ou até o próximo restart do container).
 * - divergente: a sessão está viva num pod DIFERENTE do que o banco diz. O envio
 *   bate na porta errada — é o pior dos casos e o mais silencioso.
 * - pod sem resposta: o processo não respondeu. Não se sabe nada sobre as
 *   instâncias dele; dizer "offline" aqui mandaria mover sessão saudável.
 * - oficial / sem sessão: não mora em pod nenhum.
 */
export const SITUACOES = {
    online: {
        texto: 'Online',
        cor: 'green darken-1',
        icone: 'mdi-check-circle',
        ajuda: 'Sessão carregada no pod certo e conectada ao WhatsApp.',
    },
    carregada_offline: {
        texto: 'Carregada, offline',
        cor: 'amber darken-2',
        icone: 'mdi-sleep',
        ajuda: 'O pod tem a sessão em memória, mas o socket não está aberto.',
    },
    nao_carregada: {
        texto: 'Não carregada',
        cor: 'red darken-1',
        icone: 'mdi-power-plug-off',
        ajuda: 'O banco aponta para este pod, mas ele não tem a sessão em memória.',
    },
    divergente: {
        texto: 'Divergente',
        cor: 'deep-orange darken-2',
        icone: 'mdi-arrow-decision',
        ajuda: 'A sessão está viva em outro pod: o envio vai para o endereço errado.',
    },
    pod_sem_resposta: {
        texto: 'Pod sem resposta',
        cor: 'grey darken-1',
        icone: 'mdi-help-network',
        ajuda: 'O processo não respondeu — não dá para saber o estado desta instância.',
    },
    sem_sessao: {
        texto: 'Sem sessão',
        cor: 'blue-grey',
        icone: 'mdi-qrcode',
        ajuda: 'Conexão criada mas nunca pareada — não há sessão para mover.',
    },
    oficial: {
        texto: 'API Oficial',
        cor: 'indigo',
        icone: 'mdi-check-decagram',
        ajuda: 'Canal oficial da Meta: não roda em pod.',
    },
};

export function situacao(chave) {
    return SITUACOES[chave] || { texto: chave || '—', cor: 'grey', icone: 'mdi-circle-small', ajuda: '' };
}

export const OPCOES_SITUACAO = Object.keys(SITUACOES).map(chave => ({
    value: chave,
    text: SITUACOES[chave].texto,
}));

/** Cores por status de movimentação (histórico e progresso do lote). */
export const STATUS_MOVE = {
    pendente: { texto: 'Na fila', cor: 'grey' },
    em_andamento: { texto: 'Movendo', cor: 'blue' },
    concluido: { texto: 'Concluído', cor: 'green darken-1' },
    concluido_sem_conexao: { texto: 'Moveu, não conectou', cor: 'amber darken-2' },
    falhou: { texto: 'Falhou', cor: 'red darken-1' },
    revertido: { texto: 'Revertido', cor: 'deep-orange darken-2' },
    cancelado: { texto: 'Cancelado', cor: 'blue-grey' },
};

export function statusMove(chave) {
    return STATUS_MOVE[chave] || { texto: chave || '—', cor: 'grey' };
}

/** Etapa em que o movimento está (ou parou). */
export const ETAPAS = {
    validando: 'validando',
    checando_destino: 'checando o destino',
    lendo_origem: 'lendo a origem',
    descarregando: 'descarregando da origem',
    atualizando_banco: 'atualizando o banco',
    carregando_destino: 'carregando no destino',
    confirmando: 'confirmando a conexão',
    revertendo: 'revertendo',
};

export function etapa(chave) {
    return ETAPAS[chave] || chave || '';
}
